(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elmira-home"] && !Shopify.designMode) return;
  try {
    
const initSilk = (root) => {
  root.querySelectorAll('[data-eo-silk]').forEach((el) => {
    if (el.dataset.eoReady) return;
    el.dataset.eoReady = 'true';
    if (el.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      el.classList.add('eo-silk-intro--seen');
      observer.disconnect();
    }, { threshold: 0.2 });
    observer.observe(el);
    const unload = (event) => {
      if (!event.target.contains(el)) return;
      observer.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  });
};
initSilk(document);
document.addEventListener('shopify:section:load', event => initSilk(event.target));

  } catch(e) { console.error(e); }
})();
})();
